module.exports = __webpack_public_path__ + "static/media/header.2466fa9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/siamoption/header.jpg
// module id = 1229
// module chunks = 103